import * as React from 'react';
import sortBy from 'lodash/sortBy';

import TabsSection from 'components/tabs/tabs-section/TabsSection';

import TileStandardContext from '../context/TileStandardContext';
import TileStandardTabsPopover from './popover/TileStandardTabsPopover';

import { getResidualTabData } from '../utils/tile-standard';
import { isMetricsStillFetching } from 'utils/helper/profile';

import './tile-standard-tabs.scss';

import type { TabsSectionItem } from 'types';

type Props = {
  isDisabled: boolean,
  onClick: (a: string) => void
};

const TileStandardTabs = (
  {
    isDisabled,
    onClick
  }: Props
): JSX.Element => {
  const content = React.useContext(TileStandardContext);
  const data = content ? getResidualTabData(content.channels) : [];
  const sortedData = sortBy(data, 'type');

  const handleClick = (identifier?: string | null): void => {
    if (identifier) {
      onClick(identifier);
    }
  };

  const addPopover = (): Array<TabsSectionItem> => {
    if (!content) {
      return [];
    }

    return content.tabs.map(tab => {
      const hasNoMetrics = isMetricsStillFetching(tab.metrics);
      const shouldSkipPopover = hasNoMetrics && tab.type === 'main';
      return ({
        ...tab,
        popover: shouldSkipPopover
          ? null
          : (
            <TileStandardTabsPopover
              identifier={tab.identifier}
              type={tab.type}
              metrics={tab.metrics}
              icons={sortedData.map(item => item.type || '')}
            />
          )
      });
    });
  };

  return (
    <div className="tile-standard-tabs">
      {
        content && (
          <TabsSection
            items={addPopover()}
            activeTab={content.activeTab}
            isDisabled={isDisabled}
            onClick={handleClick}
          />
        )
      }
    </div>
  );
};

export default TileStandardTabs;
